export default __webpack_public_path__ + "static/media/img.134e77d4.svg";